import React from 'react';

const PullQuote = data => {
  const { quote, title } = data;
  return <atmos-pull-quote quote={quote} title={title || ''} />;
};

export default PullQuote;
